// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCofmiSXdrUmQvl-nGjCfaKTA-W4-MfCKI",
  authDomain: "codebook-2f9f5.firebaseapp.com",
  projectId: "codebook-2f9f5",
  storageBucket: "codebook-2f9f5.appspot.com",
  messagingSenderId: "725388824315",
  appId: "1:725388824315:web:0433c5b27a5e78a9c7aa5e",
  measurementId: "G-7HE2VFJ7D7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
// const analytics = getAnalytics(app);
